import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function WhatsAppButton() {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);
  const phone = '+50683495115';
  const message = encodeURIComponent(t('whatsapp.message'));

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-3">
      <div
        className={`bg-white rounded-xl px-4 py-2.5 shadow-lg border border-purple-100 transition-all duration-300 whitespace-nowrap text-sm font-medium text-purple-800 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        {t('whatsapp.helpBubble')}
      </div>
      <a
        href={`https://wa.me/${phone}?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center shadow-lg hover:bg-teal-600 transition-all duration-300 hover:scale-110"
        aria-label="WhatsApp"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <i className="ri-whatsapp-line text-white text-2xl" />
      </a>
    </div>
  );
}